import { lazy } from 'react';
import ProfileContainer from '../components/profile/ProfileContainer';

const KolProfitContainer = lazy(() => import('../components/kol-profit/KolProfitContainer'));

const routes = [
    {
        path: "/",
        exact: true,
        element: <KolProfitContainer />
    },
    {
        path: "/profile",
        exact: true,
        element: <ProfileContainer />
    }
]

export default routes